import { Button, CircularProgress, Divider, Theme, Tooltip, Typography } from '@mui/material';
import { createStyles, makeStyles, useTheme ,} from '@mui/styles';
//| import { Theme } from '@mui/material/styles';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import clsx from 'clsx';
import { ReactNode } from 'react';
import styles from '../../styles/_variables.module.scss';
import { ReturnButton } from '../ReturnButton';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    screenTitle: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      justifyContent: 'space-between',
    },
    screenTitleWithSpaceBetween: {
      justifyContent: 'space-between',
      width: '100%',
    },
    screenInfo: {
      display: 'flex',
      alignItems: 'center',
      paddingRight: '1rem',
      gap: '0.8rem',
      '& h5': {
        fontWeight: 500,
      },
      [theme.breakpoints.down('md')]: {
        width: '100%',
        paddingRight: '0.5rem',
        '& h5': { maxWidth: 'unset', width: 'max-content' },
      },
    },
    infoIcon: {
      color: styles.slateBlue,
      fontSize: '2.3rem',
      width: '1.25rem',
      height: '1.25rem',
    },
    titleWithChild: {
      [theme.breakpoints.down('md')]: {
        gap: '1.5rem',
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
    },
    submitButton: {
      fontSize: '0.875rem',
      fontWeight: Number(styles.normalTextWeight),
    },
    extraInfo: {
      fontSize: '0.75rem',
      color: styles.slateBlue,
      height: '1.0625rem',
    },
    divider: {
      height: '1.25rem',
      width: '1px',
      backgroundColor: styles.slateBlue,
      opacity: '20%',
    },
    buttonContainer: {
      display: 'flex',
      gap: '1rem',
    },
    returnButton: {
      width: 'fit-content',
      minWidth: 'unset',
    },
    stepText: {
      fontSize: '0.8125rem',
      color: styles.slateBlue,
    },
    titleDivider: {
      width: '1px',
      backgroundColor: styles.slateBlue,
      opacity: '20%',
    },
  }),
);

interface ScreenTitleProps {
  title: string;
  elementsAmount?: number | string;
  tooltip?: string;
  children?: ReactNode;
  formId?: string;
  submitButtonText?: string;
  loading?: boolean;
  hasReturnButton?: boolean;
  step?: number;
}

function ScreenTitle({
  title,
  elementsAmount,
  tooltip,
  children,
  formId,
  submitButtonText,
  loading,
  hasReturnButton,
  step,
}: ScreenTitleProps) {
     const theme = useTheme();
   const classes = useStyles(theme);

  const buttonClasses = clsx({
    [classes.screenTitle]: true,
    [classes.screenTitleWithSpaceBetween]: hasReturnButton || children,
    [classes.titleWithChild]: children,
  });

  return (
    <div className={buttonClasses}>
      <div className={classes.screenInfo}>
        <Typography variant="h5">{title}</Typography>
        {tooltip && (
          <Tooltip title={tooltip} disableFocusListener>
            <HelpOutlineIcon className={classes.infoIcon} />
          </Tooltip>
        )}
        {step && (
          <>
            <Divider orientation="vertical" flexItem className={classes.titleDivider} />
            <Typography className={classes.stepText}>{`Paso ${step} de 2`}</Typography>
          </>
        )}
        {elementsAmount !== null && elementsAmount !== undefined && (
          <>
            <div className={classes.divider} />
            <Typography variant="subtitle2" className={classes.extraInfo}>
              {elementsAmount} elemento{elementsAmount !== 1 ? 's' : ''}
            </Typography>
          </>
        )}
      </div>
      <div className={`${children || hasReturnButton || formId ? classes.buttonContainer : ''}`}>
        {hasReturnButton && <ReturnButton />}
        {formId ? (
          <Button
            type="submit"
            color="primary"
            variant="contained"
            className={classes.submitButton}
            form={formId}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : submitButtonText || 'Guardar cambios'}
          </Button>
        ) : (
          children
        )}
      </div>
    </div>
  );
}

export default ScreenTitle;
